module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_gold_en-760164c54393c00b74acb7108e4dd8f0.png";